export default __webpack_public_path__ + "static/media/IBimageRearpendulum2.944e4082.png";